// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1m_bP","inputWrap":"Table_inputWrap__1p-ut","col":"Table_col__O-Y7M","bmiTooltip":"Table_bmiTooltip__1CahC"};